import { render, staticRenderFns } from "./VideoBox.vue?vue&type=template&id=328ee6b1&scoped=true&"
import script from "./VideoBox.vue?vue&type=script&lang=ts&"
export * from "./VideoBox.vue?vue&type=script&lang=ts&"
import style0 from "./VideoBox.vue?vue&type=style&index=0&id=328ee6b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328ee6b1",
  null
  
)

export default component.exports